/* Model */
class UndeliverableCodeModel extends App.Models.BaseModel {
    modelUrl = 'UndeliverableCode';
}

App.Models.UndeliverableCode = UndeliverableCodeModel;

/* Collection */
class UndeliverableCodeCollection extends App.Collections.BaseCollection {
    url = 'UndeliverableCode';
    model = App.Models.UndeliverableCode;
}

App.Collections.UndeliverableCodes = UndeliverableCodeCollection;

/* Router */
class UndeliverableCodeRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'UndeliverableCode';
        const model = App.Models.UndeliverableCode;
        const collectionClass = App.Collections.UndeliverableCodes;

        super(entityName, model, collectionClass);
    }
}

App.Routers.UndeliverableCode = UndeliverableCodeRouter;
